module.exports = __webpack_public_path__ + "static/media/blog1_big.9b83f026.png";